import type { TFunction } from 'i18next';
import type { CounterpartyReason } from '@/api/payees';

/**
 * The classifier's reason for a privacy or kind suggestion, in catalog words (TMMAPP-0119 item
 * 26a, TMMAPI-0157 D4; TMM-B3: never server prose). Each rail has its own sentence, so the article
 * fits the rail ("an Interac payment") in every locale. `NONE` and unknown codes are normalized to
 * null and show nothing. A company paid over a rail (`CORPORATE_MARKER` with `rail`, TMMAPI-0160 U2)
 * reads "Looks like a company paid over {rail}" (TMMAPP-0123 item 19a).
 */
export function counterpartyReasonText(
  t: TFunction,
  reason: CounterpartyReason | null,
): string | null {
  if (reason === null) return null;
  if (reason.code === 'P2P_RAIL') {
    return reason.rail === null
      ? t('payee.reason.P2P_RAIL_plain')
      : t(`payee.reasonRail.${reason.rail}`);
  }
  if (reason.code === 'CORPORATE_MARKER' && reason.rail !== null) {
    return t(`payee.reasonCorporateRail.${reason.rail}`);
  }
  return t(`payee.reason.${reason.code}`);
}
